import { AxiosPromise } from "axios"
import { userApi } from "./api"

export const getPermissions = (): AxiosPromise => userApi("/permissions")

export const checkPermissions = (userId: string): AxiosPromise =>
  userApi(`/permission/${userId}`, {
    method: "POST"
  })
